import React from "react";
import "./index.scss";
export default function PriceLine(props) {
  var price = props.price;
  var hasPrice = price && price !== "0";
  return /*#__PURE__*/React.createElement("div", {
    className: "zr-price-line"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price_wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "price rmb"
  }, "\xA5"), /*#__PURE__*/React.createElement("span", {
    className: "price money"
  }, hasPrice ? price : "议价")));
}